"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAvatarCredentials = instanceOfAvatarCredentials;
exports.AvatarCredentialsFromJSON = AvatarCredentialsFromJSON;
exports.AvatarCredentialsFromJSONTyped = AvatarCredentialsFromJSONTyped;
exports.AvatarCredentialsToJSON = AvatarCredentialsToJSON;
exports.AvatarCredentialsToJSONTyped = AvatarCredentialsToJSONTyped;
/**
 * Check if a given object implements the AvatarCredentials interface.
 */
function instanceOfAvatarCredentials(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function AvatarCredentialsFromJSON(json) {
    return AvatarCredentialsFromJSONTyped(json, false);
}
function AvatarCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'name': json['name'],
    };
}
function AvatarCredentialsToJSON(json) {
    return AvatarCredentialsToJSONTyped(json, false);
}
function AvatarCredentialsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'name': value['name'],
    };
}
//# sourceMappingURL=AvatarCredentials.js.map